/**
 * Caseload / pilot FHIR constants aligned with medplum-server `fhir-model`.
 */

import {
  ATTENDANCE_STATUS_EXT,
  EPISODE_OF_CARE_CONTEXT_EXT,
  IOP_PARENT_ENCOUNTER_EXT,
  SEED_TAG_SYSTEM,
  THERAPY_SERVICE_TYPE_SYSTEM,
} from '@unify/fhir-model/constants';

/** Local seed/reset wipe tag only — do not stamp on production staff or use as a directory filter. */
export const RBAC_PILOT_TAG_SYSTEM = SEED_TAG_SYSTEM;
export const RBAC_PILOT_TAG_CODE = 'rbac-pilot-test';

// ---------------------------------------------------------------------------
// Therapy service type coding system (canonical CodeSystem URI)
// ---------------------------------------------------------------------------

export { THERAPY_SERVICE_TYPE_SYSTEM };

export const THERAPY_SERVICE_TYPE_CODES = {
  individual: { system: THERAPY_SERVICE_TYPE_SYSTEM, code: 'individual', display: 'Individual Therapy' },
  family: { system: THERAPY_SERVICE_TYPE_SYSTEM, code: 'family', display: 'Family Therapy' },
  group: { system: THERAPY_SERVICE_TYPE_SYSTEM, code: 'group', display: 'Group Therapy' },
  iop: { system: THERAPY_SERVICE_TYPE_SYSTEM, code: 'iop', display: 'Intensive Outpatient Program' },
  couples: { system: THERAPY_SERVICE_TYPE_SYSTEM, code: 'couples', display: 'Couples Therapy' },
} as const;

// ---------------------------------------------------------------------------
// Encounter parent/child relationship (IOP)
// ---------------------------------------------------------------------------

export const IOP_PARENT_ENCOUNTER_EXTENSION = IOP_PARENT_ENCOUNTER_EXT;

// ---------------------------------------------------------------------------
// Attendance status extension
// ---------------------------------------------------------------------------

export const ATTENDANCE_STATUS_EXTENSION = ATTENDANCE_STATUS_EXT;

// ---------------------------------------------------------------------------
// Episode of Care context (chart / QuestionnaireResponse / Task / Observation)
// ---------------------------------------------------------------------------

/** Links a resource to an EpisodeOfCare when FHIR has no native field (e.g. QuestionnaireResponse). */
export const EPISODE_OF_CARE_CONTEXT_EXTENSION = EPISODE_OF_CARE_CONTEXT_EXT;
